module.exports = __webpack_public_path__ + "img/11069851_L.7ab49f72.png";